import React, { useRef, useState, useEffect } from "react"

import { DateTime } from 'luxon';
const CurrentTimeContext = React.createContext({});

const CurrentTimeProvider = ({
  children
}) => {
  const [ currentTime, setCurrentTime ] = useState(DateTime.now());
  const timer = useRef(null);

  //const debugTicker = useRef(0);

  useEffect(() => {
    timer.current = setInterval(() => {
      //if(debugTicker.current < 10)
        setCurrentTime(DateTime.now());
      /*else
        setCurrentTime(DateTime.fromISO('2021-05-16T00:01:20+09:00'));
      debugTicker.current++;

      console.log(debugTicker.current)*/
    }, 1000);

    return () => {
      clearInterval(timer.current);
    };
  }, [setCurrentTime]);


  return(<CurrentTimeContext.Provider value={{
    currentTime: currentTime
  }}>
    {children}
  </CurrentTimeContext.Provider>);

}

const useCurrentTime = () => {
  const { currentTime } = React.useContext(CurrentTimeContext);

  return {
    currentTime
  }
}

export { CurrentTimeContext, CurrentTimeProvider, useCurrentTime }
